export const DEAL = {
  company: "CANIHAVEMONEY LLC",
  target: "Company X",
  goal: 2000000,
  returnPct: 30,
  businessDays: 65,
  arBase: "$200M",
  monthlyRevenue: "$20M",
  sponsorCommitment: 200000,
};

export const STATS = [
  { value: "30%", label: "Fixed Return", sub: "over the term" },
  { value: "65", label: "Business Days", sub: "Ends ~Nov 13, 2026" },
  { value: "$2M", label: "Target Raise", sub: "total allocation" },
  { value: "$200M", label: "AR Base", sub: "collateral pool" },
];

export const BLOCKS = [
  { amount: 50000, ret: 65000, label: "Block A" },
  { amount: 100000, ret: 130000, label: "Block B" },
  { amount: 200000, ret: 260000, label: "Block C" },
];

export const TERM_SHEET = [
  ["Instrument", "Short-term AR-backed financing note"],
  ["Target Raise", "$2,000,000"],
  ["Fixed Return", "30% on committed capital"],
  ["Term", "~65 business days (approx. 3 months)"],
  ["Expected Maturity", "On or about November 13, 2026 (65 business days from funding)"],
  ["Collateral Base", "~$200M in Company X accounts receivable"],
  ["Counterparty", "Company X (~$20M monthly revenue)"],
  ["Sponsor Commitment", "Ralph / Canihavemoney LLC — $200,000"],
  ["Use of Proceeds", "Bridge financing deployed against receivables"],
  ["Repayment", "Principal + 30% at maturity (~Nov 13, 2026)"],
];

export const SUMMARY = [
  "Canihavemoney LLC is arranging a confidential, short-term financing facility backed by the accounts receivable of Company X, an operating business generating approximately $20M in monthly revenue and carrying an accounts receivable base of roughly $200M.",
  "The facility is structured to return 30% on committed capital over an expected term of approximately 65 business days. Canihavemoney LLC is pooling up to $2,000,000 from a small group of invited investors and deploying it as receivables-backed bridge financing.",
  "As a demonstration of alignment, Ralph is personally committing $200,000 to this facility alongside outside investors.",
];

export const STRUCTURE = [
  { h: "Capital Pooling", p: "Committed capital is pooled by Canihavemoney LLC into a single financing facility earmarked for Company X." },
  { h: "Deployment", p: "Funds are deployed as short-term bridge financing secured against Company X's accounts receivable (~$200M base)." },
  { h: "Collection", p: "Company X collects on its receivables over the term of the facility as invoices are paid down by their customers." },
  { h: "Repayment", p: "At maturity (~65 business days), investors receive their principal plus the fixed 30% return from collected proceeds." },
];

export const SECURITY = [
  "The facility is backed by an assignment of, and recourse against, Company X's accounts receivable, which totals approximately $200M.",
  "Company X's monthly revenue of approximately $20M provides ongoing collection activity to service the facility over its short term.",
  "This is a private, negotiated arrangement between Canihavemoney LLC and its invited investors — it is not a publicly registered or traded security.",
];

export const RISKS = [
  { h: "Principal at Risk", p: "This is an investment, not a deposit. Returns are not guaranteed and you may lose some or all of your capital." },
  { h: "Collection & Timing Risk", p: "Repayment depends on Company X collecting on its receivables on schedule. Delays or defaults by their customers could impact timing or amounts." },
  { h: "Counterparty Concentration", p: "The facility is concentrated in a single operating counterparty (Company X). Adverse events affecting that business affect the facility." },
  { h: "Illiquidity", p: "There is no secondary market. Committed capital is locked for the term and cannot be redeemed early." },
  { h: "Private Arrangement", p: "This opportunity is offered privately to invited investors only and has not been reviewed or registered with any securities regulator." },
];

export const ABOUT = [
  "Canihavemoney LLC is a private financing vehicle arranging short-duration, asset-backed opportunities for a select group of invited investors.",
  "Ralph leads the firm and personally participates in the facilities it arranges, aligning his own capital with that of outside investors.",
];

export const DISCLAIMERS = [
  "This material is strictly confidential and is provided solely for the information of invited recipients. It may not be reproduced or redistributed.",
  "Nothing herein constitutes an offer to sell, or a solicitation of an offer to buy, any security in any jurisdiction where such an offer or solicitation would be unlawful.",
  "Projected returns are targets only and are not guaranteed. Past performance is not indicative of future results. Investment involves risk, including loss of principal.",
  "Prospective investors should consult their own legal, tax, and financial advisors before committing capital. Attorney review of these terms is recommended prior to any investment.",
];

export const CONTACT = {
  name: "Canihavemoney LLC",
  address: "2067 McDonald Ave, Brooklyn, NY 11223",
  email: "ralph@canihavemoney.com",
};

export const OWNERSHIP = {
  intro: "The operating business we finance sits inside a larger, publicly-backed real estate structure — the hospital real estate is owned by one of the world's largest publicly traded hospital REITs.",
  chain: [
    { h: "Publicly Traded REIT", p: "A publicly traded healthcare REIT sits at the top of the structure — a regulated, public-company owner of the underlying hospital real estate." },
    { h: "Owns & Oversees", p: "The REIT owns the hospital properties outright and is responsible for the management company that operates them." },
    { h: "Management Company", p: "That management company — referred to here as Company X — is the operating entity Canihavemoney LLC finances against its receivables." },
  ],
  reit: {
    title: "The Owner — A Public REIT",
    points: [
      "Listed on the New York Stock Exchange",
      "One of the world's largest owners of hospital real estate",
      "Hundreds of hospital properties and tens of thousands of licensed beds",
      "A multi-billion-dollar portfolio spanning multiple countries",
      "Leases its facilities to dozens of independent hospital operators",
    ],
  },
  operator: {
    title: "The Operator — Company X",
    points: [
      "An expanding, multi-state U.S. acute-care hospital operator",
      "Approximately $20M in monthly revenue",
      "Approximately $200M accounts receivable base",
      "Backed by the REIT's real estate at the top of the structure",
      "The entity Canihavemoney LLC finances against its receivables",
    ],
  },
  note: "The REIT's and operator's identities are kept confidential and are discussed directly with committed investors.",
};

export const WATERFALL = {
  intro: "Short-term receivables financing carries timing risk. If collections run slower than expected, several layers of protection apply in order — before any investor principal is impaired.",
  steps: [
    { h: "Ongoing Collections Absorb Delays", p: "The operator keeps collecting on its ~$200M receivables base, generating ~$20M in monthly cash flow. Ordinary timing slippage is absorbed by this steady inflow rather than passed to investors." },
    { h: "Recourse to the Operator", p: "The facility carries recourse against the operating company (Company X) itself — not just a single pool of invoices — so repayment does not hinge on any one receivable clearing." },
    { h: "100× Collateral Coverage", p: "The receivables base stands at roughly 100× the $2M raise. Even a large, temporary shortfall in collections leaves the facility heavily over-collateralized." },
    { h: "Sponsor Capital Aligned", p: "Ralph's $200,000 is committed on the same terms as outside investors — sponsor capital is exposed alongside yours, never ahead of it." },
    { h: "Pro-Rata Return of Capital on Default", p: "In the event of default, the collected capital is allocated back to investors pro rata — each investor recovers in proportion to their participation amount, so no participant is subordinated to another." },
    { h: "Extension & Workout Before Loss", p: "If maturity is reached before collections complete, the facility can be extended while receivables are collected — an orderly workout is favored over a forced write-down." },
  ],
  note: "These mechanics reduce, but do not eliminate, risk. Returns are not guaranteed and principal remains at risk.",
};

export const COVERAGE = {
  ratio: "100×",
  headline: "100× collateral coverage",
  text: "The ~$200M accounts receivable base stands behind a $2,000,000 raise — roughly 100× coverage. Capital is secured against a large, diversified pool of receivables, not a single invoice.",
};

export const WORKED_EXAMPLE = {
  intro: "The return is simple to follow. There is no leverage, no market timing, and no equity exposure — just principal deployed against receivables and returned with a fixed premium at maturity.",
  rows: [
    ["You commit", "$100,000"],
    ["Capital is deployed against Company X receivables", "—"],
    ["Receivables are collected over ~65 business days", "—"],
    ["At maturity you receive principal + 30%", "$130,000"],
    ["Your net gain", "$30,000"],
  ],
  footnote: "Illustrative only. The same 30% applies across allocation sizes. Returns are targets, not guarantees.",
};

export const TIMELINE = [
  { h: "Commitment", p: "You reserve your allocation block in the portal and receive wire instructions." },
  { h: "Funding Closes", p: "Wired funds are confirmed as the facility reaches its $2M target." },
  { h: "Capital Deployed", p: "Pooled capital is deployed as receivables-backed financing to Company X." },
  { h: "Collections", p: "Receivables are collected over the ~65 business-day term." },
  { h: "Repayment", p: "Principal plus the fixed 30% return is distributed back to investors on or about November 13, 2026." },
];

// Portal per-investor status timeline (maps to commitment.status)
export const STATUS_STEPS = [
  { key: "pending", label: "Committed", desc: "Reservation recorded" },
  { key: "received", label: "Funds Received", desc: "Wire confirmed" },
  { key: "deployed", label: "Capital Deployed", desc: "Financing active" },
  { key: "repaid", label: "Repaid", desc: "Principal + 30% returned" },
];

export const FAQ = [
  { q: "Is there a minimum commitment?", a: "There is no set minimum. You may commit one of the standard blocks ($50K / $100K / $200K) or enter any custom amount." },
  { q: "How and when am I repaid?", a: "At maturity — approximately 65 business days (about three months) from funding — you receive your original principal plus a fixed 30% return, paid from collected receivables." },
  { q: "What secures my capital?", a: "The facility is backed by recourse against Company X's accounts receivable, a base of roughly $200M against a $2M raise — approximately 100× coverage." },
  { q: "Is this a publicly registered security?", a: "No. This is a private, confidential arrangement offered only to invited investors. It has not been registered with any securities regulator. Attorney review of the terms is recommended." },
  { q: "Who is Company X?", a: "The counterparty's identity is kept confidential and is discussed directly with committed investors. Publicly we share only the profile: ~$20M monthly revenue and a ~$200M receivables base." },
  { q: "Is my capital liquid?", a: "No. There is no secondary market. Committed capital is locked for the short term of the facility and cannot be redeemed early." },
  { q: "Does the sponsor invest too?", a: "Yes. Ralph is personally committing $200,000 to this facility alongside outside investors, aligning his capital with yours." },
];
